<div class="content-bg">
    <div class="main">
        <app-landing-toolbar></app-landing-toolbar>
        <div class="content-terms">
            <div class="content-text">
                <h1>Téminos y condiciones de uso</h1>
                <p>
                    Estos Términos y Condiciones de Uso (en adelante, "Términos") constituyen un acuerdo y regulan el
                    uso de nuestra plataforma (en adelante, “Plataforma” o “Plataforma Workbi”) que incluye la
                    aplicación móvil y el sitio web, y los servicios ofrecidos a través de la misma, entre el usuario
                    (aplica para el usuario que busca el servicio y para el Workbie) y WORKBI SERVICES S.A.S (en
                    adelante “Workbi”). El uso de los datos que usted comparte a Workbi y que nosotros recopilamos se
                    encuentra regulado en nuestra Política de Tratamiento de Datos Personales.
                </p>
                <ol>
                    <h4>
                        <li>Definiciones</li>
                    </h4>
                    <p>
                        <b>Workbie:</b> Persona natural, que de manera libre y voluntaria proporciona sus servicios a
                        través de la
                        Plataforma Workbi al usuario que los solicita.
                        <br>
                        <b>Datos personales:</b> Es la información que permite identificar a una persona natural o
                        jurídica.
                        <br>
                        <b>Plataforma:</b> Es una plataforma compuesta por la aplicación móvil de Workbi y el sitio web
                        por
                        medio
                        de la cual los usuarios pueden buscar servicios y conectar con el Workbie que los provee.
                        <br>
                        <b>Retenciones de ley:</b> Deducciones fiscales aplicables según la normativa vigente en
                        Colombia,
                        deducidas del pago al Workbie.
                        <br>
                        <b>Tarifa:</b> Cargo sobre el valor del servicio, pagado por el Usuario a Workbi al solicitar un
                        servicio a
                        través de la Plataforma.
                        <br>
                        <b>PSE (Proveedor de Servicios Electrónicos):</b> Es un sistema de pago en línea utilizado en
                        Colombia que
                        permite a los usuarios realizar transferencias electrónicas de fondos directamente desde sus
                        cuentas
                        bancarias a través de la plataforma de un proveedor de servicios. PSE facilita pagos seguros y
                        eficientes entre cuentas bancarias de distintas entidades financieras, permitiendo transacciones
                        en
                        tiempo real sin la necesidad de utilizar tarjetas de crédito o débito.
                        <br>
                        <b>Usuario:</b> Persona natural que utiliza la Plataforma Workbi para encontrar servicios y
                        conectar
                        con
                        Workbies que provean el servicio buscado a través de la misma.
                    </p>
                    <h4>
                        <li>Información General</li>
                    </h4>
                    <p>
                        WORKBI SERVICES S.A.S es una sociedad constituida conforme a las leyes de Colombia, identificada
                        con
                        NIT No. 901.812.872-9, domiciliada en la ciudad de Bogotá D.C., la cual para los efectos de los
                        presentes Términos se denominará “Workbi”.
                    </p>
                    <ul>
                        <p>
                            <li>
                                Funcionamiento de la Plataforma Workbi: Es una plataforma virtual, por medio de la cual
                                se
                                conectan los usuarios con los Workbies. Los usuarios a través de la Plataforma
                                solicitan un
                                servicio que necesitan y los Workbies que presten dicho servicio pueden ofertar sobre
                                dicha
                                solicitud. La oferta realizada por el Workbie, el usuario puede aceptarla o rechazarla.
                                Teniendo en cuenta que la función de la Plataforma es conectar, y
                                conforme a lo estipulado en el artículo 53 de la ley 1480 de 2011, Workbi es un portal
                                de
                                contacto.
                            </li>
                        </p>

                    </ul>
                    <h4>
                        <li>Aceptación de los términos</li>
                    </h4>
                    <ul>
                        <p>
                            <li>
                                Al usar y acceder a la Plataforma Workbi, usted está de acuerdo y reconoce expresamente
                                que
                                ha leído, entendido y aceptado estar obligado por los términos y cualquier modificación
                                o
                                adiciones futuras a estos, incluídos otros términos y políticas que se incluyen acá como
                                referencia.
                            </li>
                            <li>
                                El servicio proporcionado por el Workbie al usuario solicitante, constituirá un acuerdo
                                por
                                separado. Workbi no provee ni tiene la intención de proveer ningún servicio
                                directamente, lo
                                que hace es conectar al usuario con el Workbie que presta el servicio.
                            </li>
                            <li>
                                Al utilizar la Plataforma Workbi, usted declara y garantiza expresamente que tiene el
                                derecho legal de aceptar y estar de acuerdo con los Términos y que tiene al menos
                                dieciocho
                                (18) años de edad. Sin limitar la generalidad de lo anterior, la Plataforma no está
                                disponible para personas a las que, por cualquier motivo, les esté prohibido entablar
                                una
                                relación contractual. Al usar la Plataforma, usted declara y garantiza además que tiene
                                el
                                derecho, la autoridad y la capacidad para usar la Plataforma y cumplir con los Términos.
                            </li>
                            <li>
                                Al utilizar la Plataforma Workbi usted acepta que toda la información que proporcione a
                                Workbi será veraz y precisa. Usted garantiza que el uso de la Plataforma es
                                exclusivamente
                                para su uso personal y se compromete a no autorizar a otros a utilizar su identidad y
                                condición de usuario, y no podrá ceder ni transferir su cuenta de usuario a ninguna otra
                                persona o entidad.
                            </li>
                            <li>
                                Al usar la Plataforma, acepta cumplir con todas las leyes aplicables.
                            </li>
                            <li>
                                Si usted no acepta los términos no podrá usar ni acceder a la aplicación y/o sitio web.
                            </li>
                        </p>
                    </ul>
                    <h4>
                        <li>
                            Registro en la Plataforma
                        </li>
                    </h4>
                    <ul>
                        <p>
                            <li>
                                <b>Tipos de usuarios.</b> La Aplicación cuenta con dos tipos de usuarios: Workbies y
                                Usuarios,
                                los cuales se encuentran definidos en la sección uno (1) de los presentes términos.
                            </li>
                            <li>
                                <b>Requisitos de Registro.</b> Debe registrarse y crear una cuenta para acceder y
                                utilizar la
                                Plataforma y tener al menos 18 años de edad, proporcionando información correcta y
                                precisa. Así mismo usted acepta que notificará a Workbi cualquier cambio en la
                                información de su cuenta, ya que si no la actualiza es posible que no pueda continuar
                                usando la Plataforma.
                            </li>
                        </p>
                        <ul>
                            <p>
                                <li>
                                    La información requerida para el registro incluye: nombre, número de teléfono,
                                    correo electrónico. El usuario también podrá registrarse con su cuenta de Gmail o su
                                    número de teléfono.
                                </li>
                                <li>
                                    Workbi tiene el derecho de restringir el registro de cualquier persona si esta puede
                                    suponer una amenaza para la seguridad y la integridad de la Plataforma.
                                </li>
                            </p>
                        </ul>
                        <p>
                            <li>
                                <b>Registro de Workbie.</b> Si usted desea registrarse como Workbie, además de los
                                requisitos
                                generales mencionados anteriormente, deberá proporcionar una foto de su rostro, foto de
                                su documento de identidad por ambos lados (si tiene) y sus antecedentes judiciales que
                                serán objeto de verificación. También, declara y garantiza que tiene la capacidad de
                                prestar los servicios que ofrecerá en la Plataforma, y que además cuenta con las
                                licencias, calificaciones y/o certificados requeridos para la prestación de determinados
                                servicios. Es importante destacar que Workbi no verifica de manera independiente que los
                                Workbies cuenten con la experiencia necesaria ni que cumplan con los requisitos
                                específicos para prestar los servicios ofrecidos. Los Workbies son los únicos
                                responsables de proporcionar información veraz y de abstenerse de realizar servicios
                                para los cuales no están debidamente capacitados o certificados.
                            </li>
                        </p>
                    </ul>
                    <h4>
                        <li>Uso de la Plataforma</li>
                    </h4>
                    <ul>
                        <p>
                            <li>
                                <b>Servicio de la Plataforma y orden de la prestación del servicio.</b> La plataforma
                                permite a
                                los usuarios buscar y reservar servicios y a los Workbies ofrecer servicios y ofertar
                                las solicitudes de los usuarios. El usuario puede publicar una solicitud de prestación
                                del servicio que busca con la información necesaria como: la descripción del servicio,
                                la dirección donde el Workbie lo prestará; la fecha y hora estimada en la que requiere
                                el servicio. Varios Workbies que presten el servicio buscado podrán hacer una oferta
                                sobre la solicitud. Después de que el usuario identifique y seleccione el Workbie que
                                desea que realice el servicio se constituirá una intención de este para contratar con el
                                Workbie el servicio a cambio del pago del valor cotizado y aceptado.
                            </li>
                        </p>
                        <ul>
                            <p>
                                <li>
                                    El usuario acepta que está obligado a: (i) proporcionar datos correctos y veraces
                                    dentro de la solicitud; (ii) asumir los riesgos de las consecuencias en caso de
                                    brindar datos incorrectos en la solicitud, incluidas las que no permiten la
                                    ejecución de la misma; (iii) asegurar el paso del Workbie al lugar de la ejecución
                                    de la solicitud; y (iv) estar presente o garantizar la presencia de un tercero
                                    autorizado por él para aceptar el servicio del Workbie.
                                </li>
                                <li>
                                    El Workbie acepta que en virtud de estos Términos: (i) no se encuentra obligado a
                                    realizar un número determinado de servicios; y (ii) no se le exige exclusividad
                                    respecto del uso de la Plataforma.
                                </li>
                                <li>
                                    El Workbie no está obligado a realizar ningún servicio, pues él es quien decide a
                                    qué solicitud de prestación de servicios realizar la oferta. Sin perjuicio de lo
                                    anterior, una vez aceptada la oferta a la solicitud por parte del usuario, el
                                    Workbie se
                                    compromete a ejecutar el servicio solicitado por el usuario, de conformidad con las
                                    especificaciones otorgadas por éste, y conforme a lo establecido en los presentes
                                    Términos.
                                </li>
                            </p>
                        </ul>
                        <p>
                            <li>
                                <b>Seguridad.</b> Usted es total y exclusivamente responsable de (i) mantener la
                                confidencialidad de cualquier inicio de sesión, contraseña y nombre de usuario que usted
                                haya proporcionado o que se le haya dado para acceder a la Plataforma; y (ii) todas las
                                actividades que ocurran usando su contraseña o cuenta, incluso si es algo que usted no
                                ha autorizado. Workbi no tiene control sobre la cuenta de ningún Usuario. Usted acepta
                                notificar a Workbi de inmediato si sospecha que una parte no autorizada puede estar
                                utilizando su contraseña o cuenta de la Plataforma, o cualquier otra infracción de
                                seguridad.
                            </li>
                        </p>
                    </ul>
                    <h4>
                        <li>
                            Autonomía del Workbie.
                        </li>
                    </h4>
                    <p>
                        Estos Términos se rigen por la ley colombiana, y por su naturaleza jurídica no generan
                        relación laboral y/o de prestación de servicios entre Workbi y los Workbies, pues los
                        Workbies son independientes y autónomos, y deben asumir todas las obligaciones legales y
                        fiscales que ello conlleva. De igual forma, tampoco generan relación de representación, de
                        mandato, o de comisión entre Workbi y los Workbies.
                        <br><br>
                        El Workbie reconoce y acepta que no es empleado de Workbi. En virtud de la autorización de
                        uso de la Plataforma, el Workbie reconoce y entiende que tiene la libertad de seleccionar
                        las solicitudes de usuarios que desea ofertar y la frecuencia con la que ejecutará
                        solicitudes de servicio.
                        <br><br>
                        En virtud de lo anterior, el Workbie, en calidad de independiente, deberá cumplir con lo
                        dispuesto en el artículo 19 de la Ley 100 de 1993 con respecto a su afiliación y cotización
                        al sistema de seguridad social.
                    </p>
                    <h4>
                        <li>Limitaciones y restricciones.</li>
                    </h4>
                    <p>
                        Usted no tiene permitido: (i)Eliminar ningún aviso de derechos de autor, marcas comerciales u
                        otros avisos de propiedad de cualquier parte de la Plataforma; (ii) Modificar, crear trabajos
                        derivados, reproducir, distribuir, licenciar, arrendar, vender, revender, transferir, exhibir
                        públicamente, transmitir o utilizar de cualquier otra forma los Servicios, a menos que Workbi le
                        otorgue un consentimiento por escrito para hacerlo; (iii) Realizar ingeniería inversa,
                        descompilar, desensamblar o intentar descubrir o alterar el código fuente de los Servicios,
                        salvo que la ley aplicable lo permita; (iv) ejecutar programas o secuencias de comandos con el
                        propósito de extraer, indexar, encuestar o realizar cualquier otra forma de recopilación de
                        datos en cualquier parte de la Plataforma; (v) Intentar obtener acceso no autorizado o intentar
                        dañar cualquier parte de la Plataforma, así como sus sistemas; (vi) las demás contenidas en
                        nuestra Política de uso aceptable.
                    </p>
                    <ul>
                        <p>
                            <li>
                                <b>Conducta Prohibida.</b> Está prohibido usar la Aplicación para cualquier propósito
                                ilegal o no autorizado. Además, los usuarios y Workbies no deben intentar acceder a
                                áreas restringidas de la Plataforma.
                            </li>
                        </p>
                    </ul>
                    <h4>
                        <li>
                            Precios, pago y tarifas.
                        </li>
                    </h4>
                    <ul>
                        <p>
                            <li>
                                <b>Precio.</b> El Workbie, podrá hacer una oferta sobre la solicitud de servicio del
                                usuario.
                                La prestación del servicio se confirmará (y se formará un contrato entre usuario y
                                Workbie) cuando el usuario y el Workbie lleguen a un acuerdo sobre el precio del
                                servicio.
                            </li>
                            <li>
                                Usted acepta que estará sujeto a los impuestos, aranceles, tarifas, costos legales
                                vigentes e impuestos futuros que se introduzcan y sean aplicables.
                            </li>
                            <li>
                                <b>Tarifa.</b> Workbi puede cobrar una tarifa al usuario por el uso de los servicios de
                                la
                                Plataforma, la tarifa se especifica en la cuenta del usuario al momento de aceptar la
                                oferta que el Workbie haya realizado a su solicitud y el cobro de esta se realizará
                                cuando el usuario pague el servicio. Workbi en cualquier momento puede realizar cambios
                                en la tarifa y luego de hacerlo dar aviso, que se entenderá como aceptado por el uso
                                continuo de la aplicación después del periodo de aviso.
                            </li>
                            <li>
                                <b>Formas de pago.</b> Los pagos los podrá gestionar el usuario registrando sus medios
                                de pago
                                en la aplicación o a través de PSE.
                                <br><br>
                                En el caso en el que Workbi verifique que el método de pago seleccionado por el Usuario
                                para pagar la solicitud del servicio a través de la Plataforma Workbi está vencido, no
                                es válido, no cuenta con fondos suficientes, o cualquier otra situación que no permita
                                que el Usuario realice el pago de la solicitud, y por lo tanto el pago no sea exitoso,
                                el Usuario acepta que su solicitud no podrá continuar y el Workbie no será notificado
                                sobre la aceptación de la oferta.
                            </li>
                        </p>
                    </ul>
                    <h4>
                        <li>
                            Política de privacidad.
                        </li>
                    </h4>
                    <p>
                        El uso de sus datos personales está regulado por nuestra Política de Tratamiento de Datos
                        Personales, que se incorpora por referencia en estos Términos. Al utilizar la Plataforma, usted
                        acepta los términos de nuestra Política de Tratamiento de Datos Personales.
                    </p>
                    <h4>
                        <li>
                            Responsabilidades de Workbi
                        </li>
                    </h4>
                    <ul>
                        <p>
                            <li>
                                <b>Rol de Workbi.</b> Workbi es responsable de facilitar la conexión entre Workbies y
                                Usuarios, pero no garantiza la calidad, contratación, seguridad, ni la ejecución de los
                                servicios prestados por los Workbies.
                            </li>
                            <li>
                                <b>Exclusión de Responsabilidad.</b> Usted reconoce y acepta que Workbi únicamente
                                proporcionará la Plataforma para su uso si acepta determinadas limitaciones y
                                exclusiones de nuestra responsabilidad hacia usted y hacia terceros, tal y como se
                                establecen en esta Sección y en otras partes de los términos. POR CONSIGUIENTE, USTED
                                RECONOCE Y ACEPTA QUE, EN LA MEDIDA EN QUE LO PERMITA LA LEY APLICABLE QUE, BAJO NINGUNA
                                CIRCUNSTANCIA LAS PARTES DE WORKBI O SUS SOCIOS SERÁN RESPONSABLES (YA SEA POR CONTRATO,
                                EXTRACONTRACTUALMENTE O DE OTRO MODO) DE, Y DICHAS PARTES RECHAZAN EXPRESAMENTE,
                                CUALQUIER RESPONSABILIDAD COMO:
                            </li>
                        </p>
                        <ul>
                            <p>
                                <li>
                                    DAÑOS, YA SEAN DIRECTOS, INDIRECTOS; INCIDENTALES; CONSECUENTES; ESPECIALES,
                                    PUNITIVOS O EJEMPLARES, INCLUYENDO, PERO NO LIMITÁNDOSE A PÉRDIDAS DE INGRESOS;
                                    GANANCIAS NO OBTENIDAS; PÉRDIDA DE DATOS; INTERRUPCIÓN DEL SERVICIO; FALLO DEL
                                    SISTEMA O PÉRDIDA DE REPUTACIÓN;
                                </li>
                                <li>
                                    COSTOS LEGALES, RECLAMACIONES, DISPUTAS, PLEITOS Y/O CONTROVERSIAS DE CUALQUIER
                                    ÍNDOLE;
                                </li>
                                <li>
                                    FALLOS EN LA EJECUCIÓN DE LOS SERVICIOS PRESTADOS POR PARTE DE LOS WORKBIES; Y
                                </li>
                                <li>
                                    WORKBI NO SERÁ RESPONSABLE POR CONFLICTOS, DAÑOS, ROBOS O PERJUICIOS DERIVADOS DE
                                    LAS INTERACCIONES ENTRE USUARIOS Y WORKBIES.
                                </li>
                            </p>
                        </ul>
                        <p>
                            AL USAR LA PLATAFORMA, USTED LIBERA EXPRESAMENTE A WORKBI Y SUS SOCIOS DE CUALQUIER
                            RESPONSABILIDAD RELACIONADA CON LOS PUNTOS ANTERIORES, SALVO QUE LA LEY ESTABLEZCA LO
                            CONTRARIO.
                        </p>
                        <p>
                            <li>
                                <b>Limitación de Responsabilidad.</b> Cualquier reclamación que usted haga contra Workbi
                                estará
                                limitada al monto total de los pagos efectivamente realizados y/o adeudados por usted en
                                relación con el uso del Servicio durante el evento que dio lugar a dicha reclamación. En
                                caso de que, por ley aplicable, Workbi sea considerada responsable de daños, su
                                responsabilidad total se limitará a que: EN NINGÚN CASO LA RESPONSABILIDAD SERÁ TOTAL,
                                YA SURJA DE UN CONTRATO, EXTRACONTRACTUALMENTE, RESPONSABILIDAD OBJETIVA O DE OTRO MODO,
                                Y NO EXCEDERÁ:
                            </li>
                        </p>
                        <ul>
                            <p>
                                <li>
                                    SI USTED ES USUARIO, EL TOTAL DE LOS PAGOS QUE USTED HAYA REALIZADO A WORKBI DURANTE
                                    LOS 6 MESES ANTERIORES AL MOMENTO EN QUE SE ORIGINÓ DICHA RECLAMACIÓN; Y
                                </li>
                                <li>
                                    SI USTED ES UN WORKBIE, EL TOTAL DE LOS PAGOS DE SOLICITUDES QUE LOS CLIENTES LE
                                    HAYAN PAGADO A USTED DURANTE LOS 6 MESES ANTERIORES AL MOMENTO EN QUE SE ORIGINÓ
                                    DICHA RECLAMACIÓN, EN LA MEDIDA EN QUE LO PERMITA LA LEY APLICABLE.
                                </li>
                            </p>
                        </ul>
                        <p>
                            <li>
                                <b>Excepciones legales.</b> Nada en los términos excluye o limita cualquier
                                responsabilidad o
                                garantía que, por ley aplicable, no pueda limitarse o excluirse, incluyendo: (i)
                                Incumplimiento de obligaciones legales ineludibles en el marco del servicio de conexión
                                entre usuarios prestado por la plataforma; (ii) Casos de dolo o negligencia grave. Las
                                obligaciones legales ineludibles se limitan al marco del servicio de CONEXIÓN entre
                                usuarios que presta Workbi, evitando que pueda malinterpretarse como responsabilidad
                                sobre el servicio del Workbie.
                            </li>
                        </p>
                    </ul>
                    <h4>
                        <li>
                            Garantías
                        </li>
                    </h4>
                    <ul>
                        <p>
                            <li>
                                <b>Ausencia de Garantías de Workbi.</b> WORKBI NO HACE NINGUNA REPRESENTACIÓN NI OTORGA
                                GARANTÍA ALGUNA RESPECTO A LA CONFIABILIDAD, PUNTUALIDAD, CALIDAD, ADECUACIÓN,
                                DISPONIBILIDAD, EXACTITUD O INTEGRIDAD DE LA PLATAFORMA. WORKBI NO GARANTIZA QUE: (A) EL
                                USO DE LA PLATAFORMA SERÁ SEGURO, OPORTUNO, ININTERRUMPIDO O LIBRE DE ERRORES, NI QUE
                                FUNCIONARÁ EN COMBINACIÓN CON CUALQUIER OTRO HARDWARE, SOFTWARE, SISTEMA O DATOS; (B) EL
                                SERVICIO CUMPLIRÁ CON SUS REQUISITOS O EXPECTATIVAS; (C) CUALQUIER DATO ALMACENADO SERÁ
                                EXACTO O CONFIABLE; (D) LA CALIDAD DE CUALQUIER SERVICIO, INFORMACIÓN U OTROS MATERIALES
                                COMPRADOS U OBTENIDOS POR USTED A TRAVÉS DE LA PLATAFORMA CUMPLIRÁN CON SUS REQUISITOS O
                                EXPECTATIVAS; (E) LOS ERRORES O DEFECTOS EN LA PLATAFORMA SERÁN CORREGIDOS.
                            </li>
                            <li>
                                <b>Exclusión de Garantías Implícitas.</b> Sin perjuicio de la aplicación del Estatuto
                                del
                                Consumidor y cualquier otra ley aplicable, todas las condiciones, representaciones y
                                garantías, ya sean expresas, implícitas, estatutarias o de otro tipo, incluidas, entre
                                otras, cualquier garantía implícita de comerciabilidad, idoneidad para un propósito
                                particular, o la no infracción de los derechos de terceros, quedan expresamente
                                excluidas y renunciadas en la mayor medida permitida por la ley.
                            </li>
                            <li>
                                <b>Servicios de terceros.</b> Workbi no representa ni garantiza la confiabilidad,
                                seguridad,
                                puntualidad, calidad, idoneidad o disponibilidad de ningún servicio, incluidos, entre
                                otros, los servicios de terceros obtenidos por o de terceros a través del uso de la
                                Plataforma. Usted reconoce y acepta que todo el riesgo que surja de su uso de la
                                Plataforma y cualquier servicio de terceros, incluidos, entre otros, los servicios
                                solicitados de terceros, permanece única y absolutamente con usted y que no tendrá
                                ningún recurso contra Workbi por cualquier cuestión derivada de dichos servicios.
                            </li>
                        </p>
                    </ul>
                    <h4>
                        <li>
                            Indemnización
                        </li>
                    </h4>
                    <p>
                        Usted acepta indemnizar, defender y mantener indemne a Workbi, sus afiliados, directores,
                        empleados y agentes, de y contra cualquier reclamo, demanda, responsabilidad, daño, pérdida y
                        gasto, incluyendo, sin limitación, honorarios
                        razonables de abogados y costos derivados de o en relación con: (i) su uso de la Plataforma;
                        (ii) su violación de estos Términos; (iii) su violación de cualquier derecho de terceros,
                        incluyendo, sin limitación, cualquier derecho de propiedad intelectual o privacidad; o (iv)
                        cualquier disputa o problema entre usted y cualquier Workbie o usuario.
                    </p>
                    <h4>
                        <li>
                            Cancelaciones y Reembolsos
                        </li>
                    </h4>
                    <p>
                        La cancelación de servicios y los reembolsos, que se realizarán únicamente al usuario, se
                        regirán por nuestra Política de Cancelación y Reembolsos.
                    </p>
                    <h4>
                        <li>
                            Titularidad de la propiedad intelectual
                        </li>
                    </h4>
                    <p>
                        Todos los derechos, títulos e intereses relacionados con la Plataforma y el contenido asociado,
                        incluidos, entre otros, los derechos de autor, marcas comerciales, patentes, secretos
                        comerciales y otros derechos de propiedad intelectual, son y seguirán siendo propiedad exclusiva
                        de Workbi Services SAS y sus licenciantes. Este acuerdo no le otorga ningún derecho sobre la
                        Plataforma o el contenido asociado, salvo los permisos limitados que se le otorgan expresamente
                        en estos Términos y el contenido generado por el usuario, el Workbie y cualquier sitio web de
                        terceros que esté disponible en la Plataforma o a través de ella. Usted no tiene permitido
                        reproducir, distribuir, modificar, crear trabajos derivados, exhibir públicamente, realizar
                        públicamente, retransmitir ni utilizar de ningún modo el contenido proporcionado a través de la
                        Plataforma sin el previo consentimiento por escrito de Workbi. Cualquier uso no autorizado del
                        contenido puede violar leyes de derechos de autor, marcas comerciales y otras leyes aplicables y
                        está estrictamente prohibido. Las marcas comerciales, logotipos, marcas de servicio y nombres
                        comerciales (colectivamente, las "Marcas") que aparecen en la Plataforma son propiedad de
                        Workbi, sus licenciantes o terceros. Usted no puede utilizar estas Marcas sin el previo
                        consentimiento por escrito del propietario de las Marcas.
                    </p>
                    <ul>
                        <p>
                            <li>
                                <b>Infracción de derechos de autor.</b> Si usted considera que cualquier contenido de la
                                Plataforma infringe sus derechos de autor, por favor, notifique a Workbi proporcionando
                                una declaración escrita que incluya: (i) una descripción del material protegido por
                                derechos de autor que usted reclama que ha sido infringido; (ii) una descripción del
                                material que usted reclama que está infringiendo y donde está ubicado en el Servicio, la
                                Aplicación y/o el Software; (iii) su dirección, número de teléfono y dirección de correo
                                electrónico; (iv) una declaración suya de que cree de buena fe que el uso en disputa no
                                está autorizado por el propietario del derecho de autor, su agente o la ley; y (v) una
                                declaración suya, hecha bajo pena de perjurio, de que la información en su notificación
                                es precisa y que usted es el propietario del derecho de autor o está autorizado para
                                actuar en nombre del propietario del derecho de autor.
                            </li>
                        </p>
                    </ul>
                    <h4>
                        <li>
                            Terminación.
                        </li>
                    </h4>
                    <ul>
                        <p>
                            <li>
                                Usted puede eliminar su cuenta de Workbi en cualquier momento poniéndose en contacto con
                                nosotros por medio de los datos de contacto que se encuentran en la sección catorce
                                (14).
                            </li>
                            <li>
                                Workbi puede cancelar o suspender el acceso a su cuenta por motivo del incumplimiento de
                                los presentes Términos o cualquier Política de nosotros.
                            </li>
                        </p>
                    </ul>
                    <h4>
                        <li>
                            Modificación de los Términos
                        </li>
                    </h4>
                    <p>
                        Workbi se reserva el derecho de modificar estos Términos en cualquier momento. Se notificará a
                        los usuarios y/o Workbies de cualquier cambio mediante la publicación de los Términos
                        actualizados en la Plataforma o mediante el envío de una notificación por correo electrónico. El
                        uso continuado de la Plataforma después de la notificación de los cambios constituye la
                        aceptación de los Términos modificados.
                    </p>
                    <h4>
                        <li>
                            Información de Contacto
                        </li>
                    </h4>
                    <p>
                        Para cualquier PQRS o soporte, los usuarios pueden contactarnos a través del correo <a
                            href="mailto:pqrs@workbiservices.com">{{ mail }}</a>.
                    </p>
                </ol>
            </div>
        </div>
    </div>
    <app-landing-footer></app-landing-footer>
</div>